module.exports = __webpack_public_path__ + "img/case_04.93e49632.jpg";